import { Link, Route, Routes } from 'react-router-dom';
import { ThemeSwitch } from './components/ThemeSwitch';
import { ToastProvider } from './components/ui';
import { LibraryPage } from './features/library/LibraryPage';
import { EditorPage } from './features/editor/EditorPage';

export default function App() {
  return (
    <ToastProvider>
      <header className="mx-auto flex max-w-[1320px] flex-wrap items-end justify-between gap-3 px-4 py-5">
        <Link to="/" className="flex items-baseline gap-3">
          <span
            className="font-display text-4xl font-black leading-none"
            style={{ background: 'linear-gradient(176deg,var(--accent-2),var(--accent))', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}
          >
            SKEIN
          </span>
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-text-3">Knitting chart studio</span>
        </Link>
        <ThemeSwitch />
      </header>
      <main>
        <Routes>
          <Route path="/" element={<LibraryPage />} />
          <Route path="/p/:id" element={<EditorPage />} />
        </Routes>
      </main>
    </ToastProvider>
  );
}
